'use strict';

import React from 'react';

import FieldGroup from './FieldGroup';

import Api from '../../api/Api';

import Logger from '../../utils/Logger';

const { id: module_id } = module;
const logger = Logger(module_id);

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: {} };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.bubbleAction = this.props.bubbleAction
      ? this.props.bubbleAction
      : this.bubbleAction.bind(this);

    if (this.props.handleInputChange) {
      this.handleInputChange = props.handleInputChange.bind(this);
    }
    if (this.props.handleRadioChange) {
      this.handleRadioChange = props.handleRadioChange.bind(this);
    }
    if (this.props.handleValueChange) {
      this.handleValueChange = props.handleValueChange.bind(this);
    }
  }

  handleInputChange = (event) => {
    logger.debug(event);
    var data = this.state.data;
    data[event.target.name] = event.target.value;

    this.setState({ data: data });
  };

  handleRadioChange = (event) => {
    event.persist();
    logger.debug('handleRadioChange ', event);
    var data = this.state.data;
  };

  handleSubmit = () => {
    // send ...

    event.preventDefault();

    var stateData = this.state.data;
    Api.updateBasicinfo(stateData).then(() => {});
  };

  bubbleAction(action) {
    logger.debug('bubbled action ' + action + ' from subcomponent');

    if (action === 'save') {
      this.handleSubmit();
    }
  }

  handleValueChange = (options) => {};

  render() {
    return (
      <div className="ot-form">
        {/*{this.props.form.fieldGroups.map((data) => <FieldGroup key={data.key} data={data} values={this.props.values} bubbleAction={this.bubbleAction} handleInputChange={this.handleInputChange} handleRadioChange={this.handleRadioChange} />)}*/}
        {this.props.form.fieldGroups.map((data) => (
          <FieldGroup
            key={data.key}
            editForm={this.props.editForm}
            addForm={this.props.addForm}
            data={data}
            values={this.props.values}
            handleValueChange={this.props.handleValueChange}
            toggleEditForm={this.props.toggleEditForm}
            toggleAddForm={this.props.toggleAddForm}
            save={this.props.save}
            update={this.props.update}
            remove={this.props.remove}
          />
        ))}
      </div>
    );
  }
}

export default Form;
